

function Footer() {
  return (
    <>
      <footer>
        <div className="container">
          <div className="footer-content">
            <ul className="footer-content__1">
              <li>
                <span>CAR</span> Rental
              </li>
              <li>
                We assist in selecting the right car for your rental needs.
              </li>
              <li>
                <a href="tel:123456789">
                  <i className="fa-solid fa-phone"></i> &nbsp; +1-6478520014
                </a>
              </li>

              <li>
                <a
                  href="gleanup.adm01@gmail.com"
                >
                  <i className="fa-solid fa-envelope"></i>
                  &nbsp; gleanup.adm01@gmail.com
                </a>
              </li>

             
            </ul>
          
            <ul className="footer-content__2">
              <li>Company</li>
              <li>
              
              Cars

              </li>
            
             
              <li>
                How we work
              </li>
            </ul>
          
            <ul className="footer-content__2">
              <li>Working Hours</li>
              <li>Mon - Fri: 9:00AM - 9:00PM</li>
              <li>Sat: 9:00AM - 19:00PM</li>
              <li>Sun: 9:00AM - 12:00PM</li>
            </ul>

            <ul className="footer-content__2">
              <li>Partners</li>
              <li>
                <p>Workshops</p>
              </li>
              <li>
                <p>Outlets</p>              </li>
              
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
